import "../assets/Overlay.css";
import { defineComponent as a, useCssVars as d, computed as p, openBlock as u, createElementBlock as m, withModifiers as f, unref as s } from "vue";
import { d as k } from "./debounce.BDLEW31m.js";
import { A as C } from "./maps.DxC18PqJ.js";
import { n as O } from "./useStore.CDG6wbfK.js";
const _ = ["closeOnClick"], A = /* @__PURE__ */ a({
  __name: "Overlay",
  props: {
    closeOnClickOutside: { type: Boolean }
  },
  setup(i) {
    d((r) => ({
      "7abe1ea7": c.value
    }));
    const o = O(), t = i, c = p(() => o != null && o.rtl ? "scaleX(-1)" : "none"), e = k(() => {
      t.closeOnClickOutside && (o == null || o.handlers.callHandler(C.Dismiss));
    }, 200, { leading: !0, trailing: !1 });
    return (r, n) => (u(), m("div", {
      class: "thn--tool-overlay",
      onMousedown: n[0] || (n[0] = f(
        //@ts-ignore
        (...l) => s(e) && s(e)(...l),
        ["left"]
      )),
      onClick: n[1] || (n[1] = //@ts-ignore
      (...l) => s(e) && s(e)(...l)),
      closeOnClick: t.closeOnClickOutside
    }, null, 40, _));
  }
});
export {
  A as _
};
//# sourceMappingURL=Overlay.vue_vue_type_style_index_0_lang.oYVRTUHy.js.map
